exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-380d2c92] {\n  width: 920px !important;\n  max-width: 920px !important;\n}\n.modal-body[data-v-380d2c92] {\n  width: 920px !important;\n}\n.modal-body[data-v-380d2c92]  .custom-paginated-table {\n    max-height: 38vh;\n    min-height: 37vh;\n    overflow: auto;\n}\n.modal-body[data-v-380d2c92]  .custom-paginated-table tbody .md-table-row td {\n      border: none;\n}\n.modal-footer[data-v-380d2c92] {\n  width: 920px !important;\n}\n", ""]);

// exports
